export default __webpack_public_path__ + "static/media/iab-warning.4b39bb1d.svg";